import { render } from "./ExchangeRates.vue?vue&type=template&id=7f3b09ea&scoped=true"
import script from "./ExchangeRates.vue?vue&type=script&lang=js"
export * from "./ExchangeRates.vue?vue&type=script&lang=js"

import "./ExchangeRates.vue?vue&type=style&index=0&id=7f3b09ea&scoped=true&lang=css"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f3b09ea"]])

export default __exports__